/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Injectable } from '@angular/core';
import { Country, OtherCountries } from '@app/core/types';

@Injectable({ providedIn: 'root' })
export class Countries {
  constructor() {}

  public countries: Country[] = [
    {
      label: `United States`,
      value: 'United States',
      code: 'USA',
      shortCode: 'US',
    },
    {
      label: `Canada`,
      value: 'Canada',
      code: 'CAN',
      shortCode: 'CA',
    },
    {
      label: `United Kingdom`,
      value: 'United Kingdom',
      code: 'GBR',
      shortCode: 'GB',
    },
    {
      label: `Germany`,
      value: 'Germany',
      code: 'DEU',
      shortCode: 'DE',
    },
    {
      label: `France`,
      value: 'France',
      code: 'FRA',
      shortCode: 'FR',
    },
    {
      label: `Belgium`,
      value: 'Belgium',
      code: 'BEL',
      shortCode: 'BE',
    },
    {
      label: `Switzerland`,
      value: 'Switzerland',
      code: 'CHE',
      shortCode: 'CH',
    },
    {
      label: `Netherlands`,
      value: 'Netherlands',
      code: 'NLD',
      shortCode: 'NL',
    },
    {
      label: `Israel`,
      value: 'Israel',
      code: 'ISR',
      shortCode: 'IL',
    },
    {
      label: `Sweden`,
      value: 'Sweden',
      code: 'SWE',
      shortCode: 'SE',
    },
    {
      label: `Russia`,
      value: 'Russia',
      code: 'RUS',
      shortCode: 'RU',
    },
    {
      label: `Other Europe`,
      value: 'Other Europe',
      code: 'Other Europe',
      shortCode: OtherCountries.OTHER_EUROPE,
    },
    {
      label: `China`,
      value: 'China',
      code: 'CHN',
      shortCode: 'CN',
    },
    {
      label: `Japan`,
      value: 'Japan',
      code: 'JPN',
      shortCode: 'JP',
    },
    {
      label: `South Korea`,
      value: 'South Korea',
      code: 'KR',
      shortCode: 'KR',
    },
    {
      label: `Hong Kong`,
      value: 'Hong Kong',
      code: 'HK',
      shortCode: 'HK',
    },
    {
      label: `Taiwan`,
      value: 'Taiwan',
      code: 'TW',
      shortCode: 'TW',
    },
    {
      label: `Australia`,
      value: 'Australia',
      code: 'AUS',
      shortCode: 'AU',
    },
    {
      label: `Thailand`,
      value: 'Thailand',
      code: 'TH',
      shortCode: 'TH',
    },
    {
      label: `Singapore`,
      value: 'Singapore',
      code: 'SG',
      shortCode: 'SG',
    },
    {
      label: `Malaysia`,
      value: 'Malaysia',
      code: 'MY',
      shortCode: 'MY',
    },
    {
      label: `Philippines`,
      value: 'Philippines',
      code: 'PH',
      shortCode: 'PH',
    },
    {
      label: `Indonesia`,
      value: 'Indonesia',
      code: 'ID',
      shortCode: 'ID',
    },
    {
      label: `Vietnam`,
      value: 'Vietnam',
      code: 'VN',
      shortCode: 'VN',
    },
    {
      label: `Macau`,
      value: 'Macau',
      code: 'MO',
      shortCode: 'MO',
    },
    {
      label: `New Zealand`,
      value: 'New Zealand',
      code: 'NZ',
      shortCode: 'NZ',
    },
    {
      label: `India`,
      value: 'India',
      code: 'IND',
      shortCode: 'IN',
    },
    {
      label: `Other Asia`,
      value: 'Other Asia',
      code: 'Other Asia',
      shortCode: OtherCountries.OTHER_ASIA,
    },
    {
      label: `Brazil`,
      value: 'Brazil',
      code: 'BRA',
      shortCode: 'BR',
    },
    {
      label: `Argentina`,
      value: 'Argentina',
      code: 'ARG',
      shortCode: 'AR',
    },
    {
      label: `Other South America`,
      value: 'Other South America',
      code: 'Other South America',
      shortCode: OtherCountries.OTHER_SOUTH_AMERICA,
    },
    {
      label: `South Africa`,
      value: 'South Africa',
      code: 'ZAF',
      shortCode: 'ZA',
    },
    {
      label: `Nigeria`,
      value: 'Nigeria',
      code: 'NGA',
      shortCode: 'NG',
    },
    {
      label: `Other Africa`,
      value: 'Other Africa',
      code: 'Other Africa',
      shortCode: OtherCountries.OTHER_AFRICA,
    },
    {
      label: `Rest of the World`,
      value: 'Rest of the World',
      code: 'Rest of the World',
      shortCode: OtherCountries.REST_OF_THE_WORLD,
    },
  ];
}
